import axios from "axios";
import { apiUrl } from "../../api/common";
import { GammaDocument } from "../../types/gamma-document/GammaDocument";


export default class DocumentHandler {
  public static getDocuments() : Promise<Array<GammaDocument>> {
    return new Promise<Array<GammaDocument>> (function (resolve, reject) {
        axios.get(apiUrl + '/document' ,{}).then((response) => {
            resolve(response.data);
        }).catch((err: any) => {
            reject(err.response);
        });
    });
}
}